import React, { useEffect, useState } from "react";
import styles from "./Organization.module.css";
import Management from "./components/Management/Management";
import AccessControl from "./components/Access Control/AccessControl";
import { useDispatch, useSelector } from "react-redux";
import { getRoles } from "../../redux/slices/organizationSlice.js";
import { fetchProjectData } from "../../redux/slices/projectSlice.js";

const Organization = ({ setPage, setPageTitle }) => {
  setPage("organization");
  setPageTitle("Organization");
  const dispatch = useDispatch();

  const [managementTab, setManagementTab] = useState(true); // State to handle display of management tab
  const [accessControlTab, setAccessControlTab] = useState(false); // State to handle display of access control tab

  const [removeRoleModel, setRemoveRoleModel] = useState(false); // State to handle display of remove role model
  const [createRole, setCreateRole] = useState([]); // State to store values of new role
  const [deleteRole, setDeleteRole] = useState([]); // State to store values of role to be delete

  const [roleList, setRoleList] = useState([]); // State to store values of saved roles 
  const [updatedPermissions, setUpdatedPermissions] = useState({}); // State to store values of updated permissions

  const [rolePermissions, setRolePermissions] = useState([]); // State to store all role permissions

  const userPermission = useSelector(
    (state) => state.organization.userPermission
  ); // Stored current user permission from redux
  const allMemeberPermission = useSelector(
    (state) => state.organization.allMemeberPermission
  ); // Stored all member permission from redux

  const organizationEmail = localStorage.getItem(`organizationEmail`);
  const userEmail = localStorage.getItem("email");

  // Calling get projects api on page load
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        dispatch(fetchProjectData({ token: token, orgEmail: organizationEmail }));
      } catch (error) {
        console.log(error);
      }
    }
  }, []);

  // Calling get roles api on page load
  useEffect(() => {
    const data = {
      organizationEmail: organizationEmail,
      userEmail: userEmail,
    };
    try {
      dispatch(getRoles(data));
    } catch (error) {
      console.log(error);
    }
  }, [createRole, removeRoleModel, updatedPermissions]);

  // Storing values of in states if roles and permissions
  useEffect(() => {
    setRolePermissions(allMemeberPermission);
    setRoleList(
      allMemeberPermission?.flatMap((roleDetails, index) => {
        return Object.keys(roleDetails).filter(
          (roleName) => roleName !== "_id"
        );
      })
    );
  }, [allMemeberPermission]);

  // Function to handle display of management tab
  const handleManagementTab = () => {
    setManagementTab(true);
    setAccessControlTab(false);
  };

  // Function to handle display of access control tab
  const handleAccessControlTab = () => {
    setManagementTab(false);
    setAccessControlTab(true);
  };

  return (
    <div className={styles.organizationContainer}>
      <div className={styles.org}>
        <div className={styles.orgContent}>
          <button
            className={
              managementTab
                ? `${styles.managementTabBtn} ${styles.active}`
                : styles.managementTabBtn
            }
            onClick={handleManagementTab}
          >
            Management
          </button>
          <button
            className={
              accessControlTab
                ? `${styles.accessControlTabBtn} ${styles.active}`
                : styles.accessControlTabBtn
            }
            onClick={handleAccessControlTab}
          >
            Access Control
          </button>
        </div>
        {managementTab && (
          <Management
            deleteRole={deleteRole}
            setDeleteRole={setDeleteRole}
            roleList={roleList}
            createRole={createRole}
            setCreateRole={setCreateRole}
            removeRoleModel={removeRoleModel}
            setRemoveRoleModel={setRemoveRoleModel}
          />
        )}
        {userPermission.updatePermissions ? (
          accessControlTab ? (
            <AccessControl
              roleList={roleList}
              createRole={createRole}
              setCreateRole={setCreateRole}
              rolePermissions={rolePermissions}
              setRolePermissions={setRolePermissions}
              updatedPermissions={updatedPermissions}
              setUpdatedPermissions={setUpdatedPermissions}
            />
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default Organization;
